import { WishlistState } from '../state'
import {
  LOAD_DEFAULT_WISHLIST,
  LOAD_DEFAULT_WISHLIST_SUCCESS,
  WishlistActions
} from '../actions/wishlist.actions'

export const initialState: WishlistState = {
  defaultWishlist: {},
}

export function reducer (
  state = initialState,
  action: WishlistActions
) {
  switch (action?.type) {
    case LOAD_DEFAULT_WISHLIST: {
      return action?.payload
    }

    case LOAD_DEFAULT_WISHLIST_SUCCESS: {
      return action?.payload?.wishlist
    }

    default: return state
  }
}
